import http from '../http-common';
import { useConfigStore } from "@/store/config"
import ThlSlideMenuService from "@/services/ThlSlideMenuService";

class NavigationDataService {
    getLayoutId(id) {
        return http.get(`yja-navigation?navItemId=${id}`);
    }
    getAll(id) {
        return http.get(`yja-navigation?navItemId=${id}&children=true&ancestors=true`);
    }
    getAncestors(id) {
        return http.get(`yja-navigation?navItemId=${id}&ancestors=true`);
    }
    getChildren(id) {
        return http.get(`yja-navigation?navItemId=${id}&children=true`);
    }

    findParents(data) {
        const store = useConfigStore()
        const iterate = (obj) => {
            Object.keys(obj).forEach(key => {
                if (key === 'isChildSelected') {
                    if (obj[key]) {
                        if (obj['navItemId'] !== store.getCurrentLayoutId) {
                            store.addParent(obj['navItemId'])
                            store.addParentItem(obj)
                        }

                        // THL Slide menu
                        // Themes
                        if ( ThlSlideMenuService.useSlideMenu(obj['name']) && obj['navItemId'] !== store.getCurrentLayoutId) {
                            store.setSlideViewActive(true)
                            store.setSlideViewType("theme")
                        }
                        // Topics - when is current page
                        if (ThlSlideMenuService.isTopicPage(obj['name']) && obj['navItemId'] === store.getCurrentLayoutId) {
                            store.setSlideViewActive(true)
                            store.setSlideViewType("topic")
                            store.setSlideLayoutId(obj['navItemId'])
                        }
                        
                        // Topics - when is child page in topics branch
                        if ( ThlSlideMenuService.isTopicPage(obj['name']) && obj['navItemId'] !== store.getCurrentLayoutId) {
                            store.setSlideViewType("topic")
                            store.setSlideLayoutId(obj['navItemId'])
                        }

                        // Parent is Project page
                        if ( ThlSlideMenuService.isProjectRootPage(obj['name']) && obj['navItemId'] !== store.getCurrentLayoutId) {
                            store.setSlideViewActive(true)
                            store.setSlideViewType("projects")
                            store.setIsInProjectPages(true)
                            store.setProjectRootLayoutId(obj['navItemId'])
                        }

                    }
                }
                if (typeof obj[key] === 'object' && obj[key] !== null) {
                    iterate(obj[key])
                }
            })
        }

        iterate(data)
    }
}

export default new NavigationDataService();